// Gallery images and captions for Barma Sorig GalleryPage

export const galleryImages = [
  {
    src: "https://barma-sorig-assets.s3.ap-southeast-2.amazonaws.com/gallery-images/backward+stretch.png",
    caption: "Backward Stretch",
  },
  {
    src: "https://barma-sorig-assets.s3.ap-southeast-2.amazonaws.com/gallery-images/circle+ellfurage+on+L.+back.png",
    caption: "Circle Ellfurage on Lower Back",
  },
  {
    src: "https://barma-sorig-assets.s3.ap-southeast-2.amazonaws.com/gallery-images/effleurage.png",
    caption: "Effleurage",
  },
  {
    src: "https://barma-sorig-assets.s3.ap-southeast-2.amazonaws.com/gallery-images/face+msg.png",
    caption: "Face Massage",
  },
  {
    src: "https://barma-sorig-assets.s3.ap-southeast-2.amazonaws.com/gallery-images/face+points.png",
    caption: "Face Points",
  },
  {
    src: "https://barma-sorig-assets.s3.ap-southeast-2.amazonaws.com/gallery-images/finger+glide+(1).png",
    caption: "Finger Glide",
  },
  {
    src: "https://barma-sorig-assets.s3.ap-southeast-2.amazonaws.com/gallery-images/finger+glide+upper+back.png",
    caption: "Finger Glide Upper Back",
  },
  {
    src: "https://barma-sorig-assets.s3.ap-southeast-2.amazonaws.com/gallery-images/finger+glide.png",
    caption: "Finger Glide (1)",
  },
  {
    src: "https://barma-sorig-assets.s3.ap-southeast-2.amazonaws.com/gallery-images/foot+massage.png",
    caption: "Foot Massage",
  },
  {
    src: "https://barma-sorig-assets.s3.ap-southeast-2.amazonaws.com/gallery-images/getting+ready+for+leg+ku+nye.png",
    caption: "Getting Ready for Leg Ku Nye",
  },
  {
    src: "https://barma-sorig-assets.s3.ap-southeast-2.amazonaws.com/gallery-images/glide+side+of+ears+.png",
    caption: "Glide Side of Ears",
  },
  {
    src: "https://barma-sorig-assets.s3.ap-southeast-2.amazonaws.com/gallery-images/glide+side+of+ears.jpg",
    caption: "Glide Side of Ears (1)",
  },
  {
    src: "https://barma-sorig-assets.s3.ap-southeast-2.amazonaws.com/gallery-images/hand+msg.png",
    caption: "Hand Massage",
  },
  {
    src: "https://barma-sorig-assets.s3.ap-southeast-2.amazonaws.com/gallery-images/head+massage.png",
    caption: "Head Massage",
  },
  {
    src: "https://barma-sorig-assets.s3.ap-southeast-2.amazonaws.com/gallery-images/head+msg+points.png",
    caption: "Head Massage Points",
  },
  {
    src: "https://barma-sorig-assets.s3.ap-southeast-2.amazonaws.com/gallery-images/hold+on+base+of+skull.png",
    caption: "Hold on Base of Skull",
  },
  {
    src: "https://barma-sorig-assets.s3.ap-southeast-2.amazonaws.com/gallery-images/Hold+on+KD+points.png",
    caption: "Hold on KD points",
  },
  {
    src: "https://barma-sorig-assets.s3.ap-southeast-2.amazonaws.com/gallery-images/knuckling.png",
    caption: "Knuckling",
  },
  {
    src: "https://barma-sorig-assets.s3.ap-southeast-2.amazonaws.com/gallery-images/lower+back+circle.png",
    caption: "Last Effleurage on Lower Back",
  },
  {
    src: "https://barma-sorig-assets.s3.ap-southeast-2.amazonaws.com/gallery-images/lower+back+circle.png",
    caption: "Lower Back Circle",
  },
  {
    src: "https://barma-sorig-assets.s3.ap-southeast-2.amazonaws.com/gallery-images/lower+back.png",
    caption: "Lower Back",
  },
  {
    src: "https://barma-sorig-assets.s3.ap-southeast-2.amazonaws.com/gallery-images/lower+bag.png",
    caption: "Lower Back (1)",
  },
  {
    src: "https://barma-sorig-assets.s3.ap-southeast-2.amazonaws.com/gallery-images/oiling+foot.png",
    caption: "Oiling Foot",
  },
  {
    src: "https://barma-sorig-assets.s3.ap-southeast-2.amazonaws.com/gallery-images/oiling+on+hand.png",
    caption: "Oiling on Hand",
  },
  {
    src: "https://barma-sorig-assets.s3.ap-southeast-2.amazonaws.com/gallery-images/oiling+on+upper+back.png",
    caption: "Oiling on Upper Back",
  },
  {
    src: "https://barma-sorig-assets.s3.ap-southeast-2.amazonaws.com/gallery-images/oiling.png",
    caption: "Oiling",
  },
  {
    src: "https://barma-sorig-assets.s3.ap-southeast-2.amazonaws.com/gallery-images/palm+glide.png",
    caption: "Palm Glide",
  },
  {
    src: "https://barma-sorig-assets.s3.ap-southeast-2.amazonaws.com/gallery-images/pt+press+on+upper+back.png",
    caption: "Point Press on Upper Back",
  },
  {
    src: "https://barma-sorig-assets.s3.ap-southeast-2.amazonaws.com/gallery-images/stretch.png",
    caption: "Stretch",
  },
  {
    src: "https://barma-sorig-assets.s3.ap-southeast-2.amazonaws.com/gallery-images/thump+walk+on+arms+.png",
    caption: "Thumb Walk on Arms",
  },
  {
    src: "https://barma-sorig-assets.s3.ap-southeast-2.amazonaws.com/gallery-images/thump+walk.png",
    caption: "Thumb Walk",
  },
  {
    src: "https://barma-sorig-assets.s3.ap-southeast-2.amazonaws.com/gallery-images/working+on+neck+muscle.png",
    caption: "Working on Neck Muscle",
  },
  // ...add more images here
];
